// beatsposter.js
import poster1 from '../BeatsPoster/m1.webp';
import poster2 from '../BeatsPoster/m2.webp';
import poster3 from '../BeatsPoster/m3.webp';
import poster4 from '../BeatsPoster/m4.webp';
import poster5 from '../BeatsPoster/m5.webp';
import poster6 from '../BeatsPoster/m6.webp';
import poster7 from '../BeatsPoster/m7.webp';
import poster8 from '../BeatsPoster/m8.webp';
import poster9 from '../BeatsPoster/m9.webp';
import poster10 from '../BeatsPoster/m10.webp';
import poster11 from '../BeatsPoster/m11.webp';
import poster12 from '../BeatsPoster/m12.webp';
import poster13 from '../BeatsPoster/m13.webp';
import poster14 from '../BeatsPoster/m14.webp';
import poster15 from '../BeatsPoster/m15.webp';
import poster16 from '../BeatsPoster/m16.webp';
import poster17 from '../BeatsPoster/m17.webp';
import poster18 from '../BeatsPoster/m18.webp';
import poster19 from '../BeatsPoster/m19.webp';
import poster20 from '../BeatsPoster/m20.webp';
import poster21 from '../BeatsPoster/m21.webp';
import poster22 from '../BeatsPoster/m22.webp';
import poster23 from '../BeatsPoster/m23.webp';
import poster24 from '../BeatsPoster/m24.webp';
import poster25 from '../BeatsPoster/m25.webp';
import poster26 from '../BeatsPoster/m26.webp';
import poster27 from '../BeatsPoster/m27.webp';
import poster28 from '../BeatsPoster/m28.webp';
import poster29 from '../BeatsPoster/m29.webp';
import poster30 from '../BeatsPoster/m30.webp';
import poster31 from '../BeatsPoster/m31.webp';
import poster32 from '../BeatsPoster/m32.webp';
import poster33 from '../BeatsPoster/m33.webp';
import poster34 from '../BeatsPoster/m34.webp';
import poster35 from '../BeatsPoster/m35.webp';
import poster36 from '../BeatsPoster/m36.webp';
import poster37 from '../BeatsPoster/m37.webp';
import poster38 from '../BeatsPoster/m38.webp';
import poster39 from '../BeatsPoster/m39.webp';
import poster40 from '../BeatsPoster/m40.webp';


const beatposters = {
  poster1,
  poster2,
  poster3,
  poster4,
  poster5,
  poster6,
  poster7,
  poster8,
  poster9,
  poster10,
  poster11,
  poster12,
  poster13,
  poster14,
  poster15,
  poster16,
  poster17,
  poster18,
  poster19,
  poster20,
  poster21,
  poster22,
  poster23,
  poster24,
  poster25,
  poster26,
  poster27,
  poster28,
  poster29,
  poster30,
  poster31,
  poster32,
  poster33,
  poster34,
  poster35,
  poster36,
  poster37,
  poster38,
  poster39,
  poster40
};

export default beatposters;
